<template>
    <div>
        <modal class="edit-accounting" :display="modalStatus.editAccounting" @modalStatus="closeModal" >
            <h1>編輯記帳</h1>
            <div class="edit-accounting-wrap">
                <div class="input-wrap">
                    <span>選擇收支</span>
                    <rent-select :class="{error: error.editAccounting.type}" refName="type" :selectMsg="incomeAndExpense" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="seletcMsg.isDefault">
                        <ul>
                            <li data-id="INCOME">
                                收入
                            </li>
                            <li data-id="EXPENSE">
                                支出
                            </li>
                        </ul>
                    </rent-select>
                    <span v-show="error.editAccounting.type" class="error">{{error.editAccounting.type}}</span>
                </div>
                <div class="input-wrap">
                    <span>記帳項目</span>
                    <div class="input-error-group">
                        <input :class="{error: error.editAccounting.billName}" type="text" v-model="editAccounting.billName" placeholder="例如：廣告費用">
                    </div>
                    <span v-show="error.editAccounting.billName" class="error">{{error.editAccounting.billName}}</span>
                </div>
                <div class="input-wrap">
                    <span>總金額</span>
                    <div class="input-error-group">
                        <input :class="{error: error.editAccounting.price}" type="text" v-model="editAccounting.price" placeholder="例如：6000" >
                    </div>
                    <span v-show="error.editAccounting.price" class="error">{{error.editAccounting.price}}</span>
                </div>
                <div class="input-wrap">
                    <span>記帳時間</span>
                    <div class="input-error-group">
                        <date-picker v-model="editAccounting.billDate" :class="{'active': editAccounting.billDate != null, 'error': error.editAccounting.billDate}" :placeholder="getFormatDate(accountingDetail.recordingDate)" value-type="YYYY-MM-DD" format="YYYY.MM.DD"></date-picker>
                    </div>
                    <span v-show="error.editAccounting.billDate" class="error">{{error.editAccounting.billDate}}</span>
                </div>

            </div>
            <div class="btn-group">
                <button class="default-button confirm" @click="checkInput()">儲存</button>
                <button class="border-button reject" @click="closeModal">取消</button>
            </div>
        </modal>
    </div>
</template>
<script>
import Modal from '@/components/widge/Modal.vue';
import RentSelectHouse from '@/components/widge/RentSelectHouse.vue';
import RentSelect from '@/components/widge/RentSelect.vue';
import DatePicker from 'vue2-datepicker';
import { mapGetters } from 'vuex'

import { 
    apiAddOrUpdateLedger
    } from "@/apis/api.js"; 

export default {
    data () {
        return {
            componentKey: 0,
            editAccounting: {
                type: '',
                billName: '',
                price: null,
                billDate: null
            },
            error: {
                editAccounting:{
                    type: '',
                    billName: '',
                    price: null,
                    billDate: null
                }
            },
            houseName: '請選擇',
            houseList: [],
            selectHouse: null,
            isDefault: false,
            seletcMsg: {
                house: '請選擇房源',
                billType: '請選擇收支',
                isDefault: false
            }
        }
    },
    props: {
        accountingDetail: Object
    },
    // mounted() {
    //     if(this.modalStatus.editAccounting){
    //         console.log('編輯記帳')
    //         this.$analytics.logEvent('編輯記帳', { screen_name: '編輯記帳'})
    //     }
    // },
    watch: {
        editAccounting: {
            handler: function (val) {
                if(val.billName){
                    this.error.editAccounting.billName = ''
                }
                if(val.type){
                    this.error.editAccounting.type = ''
                }
                if(val.billDate){
                    this.error.editAccounting.billDate = ''
                }
                if(val.price){
                    if(this.checkIsNum(val.price)){
                        this.error.editAccounting.price = ''
                    }else{
                        this.error.editAccounting.price = '請填寫數字'
                    }
                }
            },
            deep: true
        },
        accountingDetail: {
            handler: function (val) {
                this.editAccounting.price = val.amount
                this.editAccounting.billName = val.itemName
                this.editAccounting.billDate = val.recordingDate
                this.editAccounting.type = val.incomeExpense
            },
            deep: true,
            immediate: true
        },
        'editAccounting.houseCid': function (val) {
            this.isDefault = false
        },
        // 'modalStatus.editAccounting': function (val) {
        //     if(val){
        //         console.log('編輯記帳')
        //         this.$analytics.logEvent('編輯記帳', { screen_name: '編輯記帳'})
        //     }
        // }
    },
    methods: {
        getSelectId: function (value) {
            // console.log(value)
            if( value.ref == 'house' ){
                this.editAccounting.houseCid = value.id
                this.seletcMsg.isDefault = true
                this.editAccounting.billDate = null
            }else if ( value.ref == 'type' ){
                this.editAccounting.type = value.id
                this.seletcMsg.isDefault = false
            }
        },
        editAccountingItem: function () {
            this.$analytics.logEvent('送出編輯記帳', { screen_name: '送出編輯記帳'})

            let data = {
                houseCid: this.accountingDetail.houseCid,
                cid: this.accountingDetail.cid,
                incomeExpense: this.editAccounting.type,
                itemName: this.editAccounting.billName,
                amount: parseInt(this.editAccounting.price),
                recordingDate: this.editAccounting.billDate
            }
            // console.log(data)
            apiAddOrUpdateLedger(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    // console.log(res)
                    this.$store.dispatch('getAccountingBookMgtList')
                    this.closeModal()
                }
            })
            .catch(err => {
                // reject(err)
            })
        },
        closeModal: function (type) {
            this.$store.dispatch('setModalStatus', {state: false, type: 'editAccounting'})
            this.editAccounting = {
                houseCid: '',
                type: '',
                billName: '',
                price: null,
                billDate: null
          
            }
            this.error.editAccounting = {
                houseCid: '',
                type: '',
                billName: '',
                price: null,
                billDate: null
            }
            this.isDefault = true
            this.componentKey += 1
        },
        checkIsNum: function (num) {
            let numerical = /^[0-9]*$/
            return numerical.test(num)?true:false
        },
        checkInput: function () {
            if(!this.editAccounting.billName){
                this.error.editAccounting.billName = '請填寫帳單名稱'
            }else{
                this.error.editAccounting.billName = ''
            }

            if(!this.editAccounting.price){
                this.error.editAccounting.price = '請填寫金額'
            }else{
                this.error.editAccounting.price = ''
            }
            if(!this.editAccounting.billDate){
                this.error.editAccounting.billDate = '請選擇記帳時間'
            }else{
                this.error.editAccounting.billDate = ''
            }
            if(!this.editAccounting.type){
                this.error.editAccounting.type = '請選擇收支'
            }else{
                this.error.editAccounting.type = ''
            }
            if(
                this.editAccounting.billName &&
                this.editAccounting.type &&
                this.editAccounting.price &&
                this.editAccounting.billDate
            ){
                this.editAccountingItem()
            }
        },
        checkHouse: function () {
            if(!this.editAccounting.contractCid){
                this.error.editAccounting.houseCid = '請先選擇房源'
            }else{
                this.error.editAccounting.houseCid = ''
            }
        },
        getFormatDate: function (time){
            var formatDate = [];
            var date = new Date(time);
            //一般日期 年 月 天 時 分
            formatDate[0] = date.getFullYear();
            formatDate[1] = date.getMonth()+1;
            formatDate[2] = date.getDate();
            formatDate[3] = (Array(2).join(0)+date.getHours(-8)).slice(-2);
            formatDate[4] = (Array(2).join(0)+date.getMinutes()).slice(-2);
            //月及天兩位數
            formatDate[5] = (Array(2).join(0)+formatDate[1]).slice(-2);
            formatDate[6] = (Array(2).join(0)+formatDate[2]).slice(-2);
            // console.log(formatDate[3] )
            //換算時區 台灣-8
            if(formatDate[3] - 8 < 0){
                formatDate[3] = 24+(formatDate[3]-8);
                formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            }else{
                formatDate[3] = formatDate[3]-8;
                formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            }
            return formatDate[0]+'-'+formatDate[5]+'-'+formatDate[6];
        },
    },
    computed: {
        filterHouse: function () {
            return this.houseList.filter((house) => {
                if( this.selectHouse ){
                    if(house.address.includes(this.selectHouse)){
                        return house
                    }
                }else{
                    return house
                }
            });
        },
        incomeAndExpense: function () {
            if(this.editAccounting.type == 'INCOME'){
                return '收入'
            }else{
                return '支出'
            }
        },
        ...mapGetters({
            modalStatus: 'GET_MODAL_STATUS',
        })
    },
    components: {
        Modal,
        RentSelectHouse,
        RentSelect,
        DatePicker
    }
}
</script>
<style lang="scss"  >
    #modal.edit-accounting{
        .error{
            right: 0px;
            top: 7px;
        }
        .modal-content{
            width: 448px;
            padding: 0 !important;
            .detail{
                >h1{
                    margin-top: 32px;
                    margin-bottom: 24px;
                }
                .edit-accounting-wrap{
                    padding: 0 32px 0 32px;
                    .input-wrap{
                        position: relative;
                        margin-bottom: 24px;
                        >span{
                            display: block;
                            margin-bottom: 12px;
                        }
                        >.input-error-group{
                            >input{
                                width: 352px;
                            }
                        }
                        .rent-select{
                            >span{
                                color: #292625 !important;
                            }
                        }
                    }
                    .mx-datepicker{
                        width: 384px;
                        input{
                            height: 46px;
                            border-radius: 4px;
                            border: solid 1px #e0dfde;
                            color: #a8a5a4;
                            padding: 13px 16px;
                            box-shadow: none;
                            margin-bottom: 0px;
                        }
                        .mx-icon-calendar,
                        .mx-icon-clear{
                            right: 14px;
                        }
                    }
                    .mx-datepicker.error{
                        input{
                            border: solid 1px #fc7171 !important;
                        }
                    }
                    .mx-datepicker:hover,
                    .mx-datepicker.active{
                        ::-webkit-input-placeholder { color: #676362; }
                        input::-moz-placeholder{
                            color:#676362;
                        }
                        input{
                            border: 1px solid #676362 ;
                            color: #676362 !important;
                        }
                        i{
                            color: #676362;
                        }
                    }
                    span.error {
                        right: 0;
                        top: 3px;
                        left: unset;
                        bottom: unset;
                    }
                    
                }
            }
            
            .btn-group{
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100%;
                height: 84px;
                box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                border-radius:  0 0 20px 20px;
                margin: 0 auto;
                button{
                    width: 184px;
                    height: 44px;
                }
                button.confirm{
                    margin-right: 16px;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/widge/editAccounting.vue